import { render, staticRenderFns } from "./menuClinica.vue?vue&type=template&id=e061f23c&scoped=true"
import script from "./menuClinica.vue?vue&type=script&lang=js"
export * from "./menuClinica.vue?vue&type=script&lang=js"
import style0 from "./menuClinica.vue?vue&type=style&index=0&id=e061f23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e061f23c",
  null
  
)

export default component.exports